import React, { useState } from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

// ✅ Brand Data (LOCAL IMAGES – SAFE)
const brands = [
  { name: "Hindware", logo: "/images/L-1.png" },
  { name: "Jaquar", logo: "/images/l2.png" },
  { name: "Simpolo", logo: "/images/l3.png" },
  { name: "Johnson", logo: "/images/l4.png" },
  { name: "ACC", logo: "/images/l5.png" },
  { name: "Kajaria", logo: "/images/l6.png" },
  { name: "Ultratech", logo: "/images/l7.png" },
  { name: "Jindal", logo: "/images/l8.png" },
  { name: "Asian Paints", logo: "/images/l9.png" },
  { name: "Somany", logo: "/images/l10.png" },
  { name: "Somany", logo: "/images/l11.jpg" },
  { name: "Somany", logo: "/images/l12.jpg" },
];

// ✅ Image with fallback
const ImageWithFallback = ({
  src,
  alt,
  className,
}: {
  src: string;
  alt: string;
  className?: string;
}) => {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      //loading="lazy"
      //decoding="async"
      onError={() => setImgSrc("/images/placeholder.png")}
    />
  );
};

const MaterialsSection: React.FC = () => {
  return (
    <section className="relative py-20 bg-gradient-to-b from-white via-gray-50 to-white dark:from-gray-950 dark:via-gray-900 dark:to-black overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center relative z-10">

        {/* 🔹 Background Watermark */}
        <h1 className="absolute inset-0 flex items-center justify-center text-7xl md:text-9xl font-extrabold text-gray-200/30 dark:text-gray-800/20 select-none tracking-widest">
          MATERIALS
        </h1>

        {/* 🔹 Heading */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="relative mb-12"
        >
          <div className="flex justify-center items-center space-x-3 mb-4">
            <span className="h-[2px] w-12 bg-yellow-500 rounded-full"></span>
            <span className="text-yellow-500 text-xl">🏗️</span>
            <span className="h-[2px] w-12 bg-yellow-500 rounded-full"></span>
          </div>

          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white">
            Materials{" "}
            <span className="bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">
              We Prefer
            </span>
          </h2>

          <p className="mt-6 max-w-3xl mx-auto text-gray-600 dark:text-gray-400 text-lg leading-relaxed">
            We use top-quality materials from trusted brands like ACC, Ultratech,
            Jindal, and Kajaria for durability and style. Our selections also
            include Simpolo, Somany Tiles and Jaquar fittings. These choices
            ensure excellence in every project.
          </p>
        </motion.div>

        {/* 🔹 Brand Slider */}
        <Swiper
  modules={[Autoplay]}
  autoplay={{ delay: 0, disableOnInteraction: false }}
  loop
  speed={4000}
  slidesPerView={2}
  breakpoints={{
    640: { slidesPerView: 3 },
    768: { slidesPerView: 4 },
    1024: { slidesPerView: 5 },
  }}
  spaceBetween={30}
>
  {brands.map((brand, idx) => (
    <SwiperSlide key={idx}>
      <motion.div
        whileHover={{ scale: 1.05 }}
        transition={{ type: "spring", stiffness: 180 }}
        className="
          relative flex items-center justify-center
          h-[110px]
          bg-white dark:bg-gray-800
          rounded-xl
          shadow-md hover:shadow-xl hover:shadow-yellow-400/30
          overflow-hidden
        "
      >
        <ImageWithFallback
          src={brand.logo}
          alt={brand.name}
          className="
            w-full h-full
            object-contain
            transition-transform duration-300
          "
        />
      </motion.div>
    </SwiperSlide>
  ))}
</Swiper>


      </div>
    </section>
  );
};

export default MaterialsSection;
